

export const Capital = {
    Name: 'Capital',
    Code: 'CAPITAL',
    Description: 'Capital Account',
    Depth: 2,
    PathIndex: 2,
    LocationAccType: 2,
    State: 'LocationActive'
}

export const Receivable = {
    Name: 'Receivable',
    Code: 'RECEIVABLE',
    Description: 'Receivable Account',
    Depth: 3,
    PathIndex: 2,
    LocationAccType: 1,
    State: 'VentueActive'
}

export const Drawing = {
    Name: 'Drawing',
    Code: 'DRAWING',
    Description: 'Drawing Account',
    Depth: 3,
    PathIndex: 2,
    LocationAccType: 3,
    State: 'LocationActive'
}

export const AccountType = {
    Capital: '79375D1C-5359-4953-BC80-E945C60E86F1',
    Drawing: 'E5E890D4-C3D3-4D0B-B363-BD3D3BB7E748',
    AccountReceivable: '94D34F09-CC4F-4768-A916-E62837FB00A9'
}

export const ParentAccount = {
    Capital: '050AC693-05C0-4997-92BA-8E5B77608129',
    Drawing: 'A273FF0E-E375-4F32-A423-78D3C0C4823F',
    AccountReceivable: 'ACF79782-F487-4650-A006-C27382D9E2A4'
}